import React, { useState } from 'react';
import "./styles.css";
import Button from "../../components/Button";
import { Grid, TextField } from "@mui/material";
import DialogComp from "../../components/Dialog-Popup";

const Footer = ({ handleFooter }) => {
    const [openPopup, setOpenPopup] = useState(false);
    const [popuptitle, SetPopupTitle] = useState("");
    const [description, setDescription] = useState("");
    const [popupContent, SetPopupContent] = useState("");
    const [buttonArr, setButtonArr] = useState([]);

    function sendFunc() {
        setOpenPopup(true);
        SetPopupTitle("Message Sent!");
        SetPopupContent("Your message has been shared successfully with the service provider.");
        let btnValues = [
            {
                id: "1",
                value: "Ok",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: closeFunc,
            }
        ];
        setButtonArr(btnValues);
    }

    function onholdFunc() {

        setOpenPopup(true);
        SetPopupTitle("Are you sure?");
        SetPopupContent(
            ["You are trying to Hold the selected user profile request.",
                <br />,
                "Please click on proceed if you would like to continue."
            ]
        );
        let btnValues = [
            {
                id: "1",
                value: "PROCEED",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: ProceedHoldFunc,
            },
            {
                id: "2",
                value: "Cancel",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: cancelFunc,
            },
        ];
        setButtonArr(btnValues);


    }

    function ProceedHoldFunc() {
        setOpenPopup(true);
        SetPopupTitle("Profile is on Hold!");
        SetPopupContent(["You have marked the profile details are on hold.",
            <br />,
            "Please add your reason to keep the profile on hold and this will shared with service provider for further actions."]);
        let btnValues = [
            {
                id: "1",
                value: "Add Comment",
                color: "borderLess",
                fontSize: "16px",
                functionCall: handleComment,
            },
            {
                id: "2",
                value: "Cancel",
                color: "borderLess",
                fontSize: "16px",
                fontfamily: 'Rubik',
                functionCall: cancelFunc,
            },
        ];
        setButtonArr(btnValues);

    }

    function handleComment() {
        setOpenPopup(true);
        SetPopupTitle("Add your comment");
        SetPopupContent(

            <TextField
                id="inputID"
                className='text_container'
                multiline
                sx={{
                    width: "100%",

                }}
                placeholder="type here..."
                rows={3}
                variant="outlined"
                values={description}
                onChange={(e) => {
                    setDescription(e.target.value);
                }}
            />

        );
        let btnValues = [
            {
                id: "1",
                value: "CANCEL",
                color: "borderLess",
                fontSize: "16px",
                fontfamily: 'Rubik',
                functionCall: cancelFunc,

            },
            {
                id: "2",
                value: "SEND",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: sendFunc,
            },
        ];
        setButtonArr(btnValues);

    }
    function rejectFunc() {

        setOpenPopup(true);
        SetPopupTitle("Are you sure?");
        SetPopupContent(
            ["You are trying to Reject the selected user profile request.",
                <br />,
                "Please click on proceed if you would like to continue."
            ]
        );
        let btnValues = [
            {
                id: "1",
                value: "PROCEED",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: ProceedRejFunc,
            },
            {
                id: "2",
                value: "Cancel",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: cancelFunc,
            },
        ];
        setButtonArr(btnValues);


    }

    function ProceedRejFunc() {
        setOpenPopup(true);
        SetPopupTitle("Profile Rejected!");
        SetPopupContent(
            ["The profile has been marked rejected and the user will not be able to take up any Service requests.",
                <br />, <br />,
                "User will get notified with the profile update."
            ]
        );
        let btnValues = [
            {
                id: "1",
                value: "Ok",
                color: "borderLess",
                fontfamily: 'Rubik',
                fontSize: "16px",
                functionCall: closeFunc,
            },

        ];
        setButtonArr(btnValues);

    }
    function closeFunc() {
        setOpenPopup(false)
        handleFooter(false)
    }

    function cancelFunc() {
        setOpenPopup(false);

    }
    function ApprovedFuncconfrm() {

        setOpenPopup(true);
        SetPopupTitle("Are you sure?");
        SetPopupContent(
            ["You are trying to Approve the selected user profile request.",
                <br />,
                "Please click on proceed if you would like to continue."]
        );
        let btnValues = [
            {
                id: "1",
                value: "PROCEED",
                color: "borderLess",
                fontSize: "16px",
                fontfamily: 'Rubik',
                functionCall: proceedFunc,
            },
            {
                id: "2",
                value: "CANCEL",
                color: "borderLess",
                fontSize: "16px",
                fontfamily: 'Rubik',
                functionCall: cancelFunc,
            },
        ];
        setButtonArr(btnValues);


    }


    function proceedFunc() {


        setOpenPopup(true);
        SetPopupTitle("Profile Approved!");
        SetPopupContent(
            ["The profile has been marked approved and the user will notified with the new profile update.",
                <br />, <br />,
                "This user can now access service request from Home Owners."]
        );
        let btnValues = [
            {
                id: "1",
                value: "Ok",
                color: "borderLess",
                fontSize: "16px",
                fontfamily: 'Rubik',
                functionCall: closeFunc,
            },

        ];
        setButtonArr(btnValues);

    }

    return (
        <div className="main-footer">
            <Grid style={{ display: 'flex', width: '100%' }}>
                <Grid sx={{ width: '13%', marginLeft: '26%' }}>
                    <Button
                        color="rejectColor"
                        opacity="1"
                        name="Reject Request"
                        onClick={rejectFunc}
                    />
                </Grid>

                <Grid sx={{ width: '13%', marginLeft: '3%' }}>
                    <Button
                        color="primary"
                        opacity="1"
                        name="Mark On Hold"
                        onClick={onholdFunc}

                    />
                </Grid>
                <Grid style={{ marginLeft: '1%' }}>
                    <Button
                        color="green"
                        opacity="1"
                        name="Approve Request"
                        onClick={ApprovedFuncconfrm}
                    />
                </Grid>
            </Grid>
            <DialogComp
                openPopup={openPopup}
                popuptitle={popuptitle}
                popupContent={popupContent}
                buttonValue={buttonArr}
            />

        </div>
    )
}

export default Footer;